import React, { useEffect, useMemo, useState } from "react";
import { Alert, Card, CardTitle, Label, Spinner, Col as RsCol } from "reactstrap";
import { Button, Col, Icon, Row } from "../../../../../../../../components/Component";
import * as app_consts from "../../../../../../../../constants/react_app_consts";
import { employee_dashboard_actions_helper } from "../../../../../../../../actions/actions_helper";
import {
  ADD_GRN_FROM_NOT_SET_WEIGHBRIDGE_TICKET_API,
  CREATE_WAREHOUSE_DELIVERY_GRN_API,
  RETRIEVE_ACTIVE_PRODUCT_LIST,
  RETRIEVE_ACTIVE_PRODUCT_TYPES_LIST,
} from "../../../../../../../../api/api_data";
import {
  CREATE_GOODS_RECEIVED_TICKET_ACCESS_DENIED_MSG,
  CREATE_GOODS_RECEIVED_TICKET_ERR_MSG,
  CREATE_GOODS_RECEIVED_TICKET_SUCCESS_MSG,
  RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG,
  RETRIEVE_PRODUCTS_LIST_ERR_MSG,
  RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
  RETRIEVE_PRODUCT_TYPES_LIST_ACCESS_DENIED_MSG,
  RETRIEVE_PRODUCT_TYPES_LIST_ERR_MSG,
  RETRIEVE_PRODUCT_TYPES_LIST_SUCCESS_MSG,
} from "../../../../../../../../constants/success_error_messages_consts";
import { messageToast } from "../../../../../../../../utils/Utils";
import { useSelector, useDispatch } from "react-redux";
import TextInput from "../../../../../../../components/inputs/TextInput";
import ModalPreview from "../../../../../modal/modal_preview/ModalPreview";
import {
  fail_create_goods_recieved_ticket,
  loading_create_goods_recieved_ticket,
  reset_create_goods_recieved_ticket,
  success_create_goods_recieved_ticket,
} from "../../../../../../../../reducers/dashboard_reducers/warehouse/create_goods_received_ticket_Slice";
import {
  fail_product_type_list,
  loading_product_type_list,
  reset_product_type_list,
  success_product_type_list,
} from "../../../../../../../../reducers/dashboard_reducers/products/product_type_list_Slice";
import {
  fail_product_list,
  loading_product_list,
  reset_product_list,
  success_product_list,
} from "../../../../../../../../reducers/dashboard_reducers/products/product_list_Slice";
import {
  formatWeighbridgeWeightInputMt,
  resolveGrnNetWeight,
  isGrnWeightSequenceValid,
} from "../../../../../../../../utils/weighbridgeUtils";
import { resolveWeighbridgeTicketPrefillData } from "../../../../../../../../utils/weighbridgeTicketNormalization";

const hasFormValue = (value) => value !== null && value !== undefined && value !== "";

const convertTicketPrefillWeightsToMt = (ticketPrefill = {}) => ({
  ...ticketPrefill,
  first_weight: formatWeighbridgeWeightInputMt(ticketPrefill?.first_weight),
  second_weight: formatWeighbridgeWeightInputMt(ticketPrefill?.second_weight),
  net_weight: formatWeighbridgeWeightInputMt(
    resolveGrnNetWeight(
      ticketPrefill?.net_weight,
      ticketPrefill?.first_weight,
      ticketPrefill?.second_weight,
    ),
  ),
});

const applyTicketPrefillToDeliveryForm = (formData = {}, selectedTicketPrefill = {}) => ({
  ...formData,
  transporter_name: hasFormValue(formData?.transporter_name)
    ? formData.transporter_name
    : selectedTicketPrefill?.transporter_name || "",
  truck_driver_name: hasFormValue(formData?.truck_driver_name)
    ? formData.truck_driver_name
    : selectedTicketPrefill?.truck_driver_name || "",
  truck_licence_plate: hasFormValue(formData?.truck_licence_plate)
    ? formData.truck_licence_plate
    : selectedTicketPrefill?.truck_licence_plate || "",
  trailer_one: hasFormValue(formData?.trailer_one)
    ? formData.trailer_one
    : selectedTicketPrefill?.trailer_one || "",
  trailer_two: hasFormValue(formData?.trailer_two)
    ? formData.trailer_two
    : selectedTicketPrefill?.trailer_two || "",
  comments: hasFormValue(formData?.comments)
    ? formData.comments
    : selectedTicketPrefill?.comments || "",
  first_weight: hasFormValue(formData?.first_weight)
    ? formData.first_weight
    : selectedTicketPrefill?.first_weight || "",
  second_weight: hasFormValue(formData?.second_weight)
    ? formData.second_weight
    : selectedTicketPrefill?.second_weight || "",
  net_weight: hasFormValue(formData?.net_weight)
    ? formData.net_weight
    : selectedTicketPrefill?.net_weight || "",
  weighbridge_ticket_id: hasFormValue(formData?.weighbridge_ticket_id)
    ? formData.weighbridge_ticket_id
    : selectedTicketPrefill?.weighbridge_ticket_id || "",
  branch_location_id: hasFormValue(formData?.branch_location_id)
    ? formData.branch_location_id
    : selectedTicketPrefill?.branch_location_id || "",
  branch_location_name: hasFormValue(formData?.branch_location_name)
    ? formData.branch_location_name
    : selectedTicketPrefill?.branch_location_name || "",
  weigh_bridge_ticket_number: hasFormValue(formData?.weigh_bridge_ticket_number)
    ? formData.weigh_bridge_ticket_number
    : selectedTicketPrefill?.weigh_bridge_ticket_number || "",
  weigh_bridge_ticket_reference_no: hasFormValue(formData?.weigh_bridge_ticket_reference_no)
    ? formData.weigh_bridge_ticket_reference_no
    : selectedTicketPrefill?.weigh_bridge_ticket_reference_no || "",
  external_weigh_bridge_ticket_number: hasFormValue(formData?.external_weigh_bridge_ticket_number)
    ? formData.external_weigh_bridge_ticket_number
    : selectedTicketPrefill?.external_weigh_bridge_ticket_number || "",
  source_system: hasFormValue(formData?.source_system)
    ? formData.source_system
    : selectedTicketPrefill?.source_system || "",
  sync_batch_id: hasFormValue(formData?.sync_batch_id)
    ? formData.sync_batch_id
    : selectedTicketPrefill?.sync_batch_id || "",
  designation: hasFormValue(formData?.designation)
    ? formData.designation
    : selectedTicketPrefill?.designation || "",
  raw_payload: formData?.raw_payload || selectedTicketPrefill?.raw_payload || null,
  weighbridge_ticket_data:
    formData?.weighbridge_ticket_data || selectedTicketPrefill?.weighbridge_ticket_data || null,
});

const TruckDetailsStep = ({
  weighBridgeFormData,
  setWeighBridgeFormData,
  truck_accounts_list,
  loadingList,
  refreshList,
  sentStep,
  prevStep,
  nextStep,
  setContinueProcessingData,
  selectedWeighbridgeTicket,
}) => {
  const [errorVal, setErrorVal] = useState("");
  const [formData, setFormData] = useState(weighBridgeFormData);
  const [listLoading, setListLoading] = useState(loadingList);
  const [addTrailer, setAddTrailer] = useState(false);
  const dispatch = useDispatch();
  const [openPreview, setOpenPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const selectedTicketPrefill = useMemo(
    () => resolveWeighbridgeTicketPrefillData(selectedWeighbridgeTicket),
    [selectedWeighbridgeTicket],
  );
  const selectedTicketPrefillMt = useMemo(
    () => convertTicketPrefillWeightsToMt(selectedTicketPrefill),
    [selectedTicketPrefill],
  );
  const effectiveFormData = applyTicketPrefillToDeliveryForm(formData, selectedTicketPrefillMt);

  const isWeighbridgeLocked = !!weighBridgeFormData?.weighbridge_locked;
  const isWeighbridgePrefilled = !!weighBridgeFormData?.weighbridge_prefilled;

  const LOCKED_FIELDS = [
    "transporter_name",
    "truck_driver_name",
    "truck_licence_plate",
    "first_weight",
    "second_weight",
    "net_weight",
  ];

  useEffect(() => {
    setFormData(applyTicketPrefillToDeliveryForm(weighBridgeFormData, selectedTicketPrefillMt));
  }, [selectedTicketPrefillMt, weighBridgeFormData]);

  useEffect(() => {
    if (sentStep === 2) {
      retrieve_product_type_list();
      retrieve_product_list();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sentStep]);

  useEffect(() => {
    setListLoading(loadingList);
  }, [loadingList]);

  useEffect(() => {
    if (!selectedWeighbridgeTicket) return;
    const selectedTicketId =
      selectedTicketPrefill?.weighbridge_ticket_id ||
      selectedWeighbridgeTicket?.weighbridge_ticket_id ||
      selectedWeighbridgeTicket?.weigh_bridge_ticket_id ||
      selectedWeighbridgeTicket?.id ||
      "";

    const nextFormData = applyTicketPrefillToDeliveryForm(
      {
        ...formData,
        weighbridge_ticket_id: selectedTicketId || formData.weighbridge_ticket_id || "",
        weighbridge_ticket_data: selectedWeighbridgeTicket || formData.weighbridge_ticket_data || null,
      },
      selectedTicketPrefillMt,
    );

    setFormData(nextFormData);
    setWeighBridgeFormData({
      ...nextFormData,
      weighbridge_locked: false,
      weighbridge_prefilled: true,
    });
  }, [selectedTicketPrefillMt, selectedWeighbridgeTicket]);

  const previousStep = () => {
    setWeighBridgeFormData({
      ...weighBridgeFormData,
      ...formData,
    });
    prevStep();
  };

  const handleChange = (e) => {
    if (isWeighbridgeLocked && LOCKED_FIELDS.includes(e.target.name)) {
      return;
    }

    const nextFormData = { ...effectiveFormData, [e.target.name]: e.target.value };

    if (e.target.name === "first_weight" || e.target.name === "second_weight") {
      nextFormData.net_weight =
        nextFormData.first_weight && nextFormData.second_weight
          ? resolveGrnNetWeight(
              nextFormData.net_weight,
              nextFormData.first_weight,
              nextFormData.second_weight,
            )
          : "";
    }

    setFormData(nextFormData);
    setWeighBridgeFormData(nextFormData);
  };

  const handlePreview = () => {
    setErrorVal("");
    setOpenPreview(true);
  };

  const handleSubmit = () => {
    setErrorVal("");
    setOpenPreview(false);
    const submissionData = applyTicketPrefillToDeliveryForm(formData, selectedTicketPrefill);

    console.log("FINAL FORM DATA =>", submissionData);
    console.log("FINAL USER ACCOUNT ID =>", submissionData.user_account_id);
    console.log("FINAL CONSIGNER TYPE ID =>", submissionData.consigner_type_id);

    const requiresUserAccount =
      submissionData.consigner_type !== app_consts.UAG_CONSIGNER_STRING &&
      submissionData.consigner_type !== app_consts.OTHER_CONSIGNER_STRING;

    if (requiresUserAccount && !submissionData.user_account_id) {
      setErrorVal("User Account ID cannot be empty.");
      messageToast("Please select or set a valid user account before creating the ticket.", app_consts.FAIL);
      return;
    }

    if (
      submissionData.consigner_type === app_consts.OTHER_CONSIGNER_STRING &&
      !submissionData.other_consigner_name
    ) {
      setErrorVal("Other supplier name cannot be empty.");
      messageToast("Please provide the supplier name for the other consigner.", app_consts.FAIL);
      return;
    }

    if (
      submissionData.first_weight &&
      submissionData.second_weight &&
      !isGrnWeightSequenceValid(
        submissionData.first_weight,
        submissionData.second_weight,
        submissionData.net_weight,
      )
    ) {
      setErrorVal("First weight (gross) must be greater than or equal to second weight (tare).");
      messageToast("First weight (gross) must be greater than or equal to second weight (tare).", app_consts.FAIL);
      return;
    }

    const hasExternalWeighbridgeTicket = Boolean(
      submissionData.external_weigh_bridge_ticket_number ||
      selectedWeighbridgeTicket?.external_weigh_bridge_ticket_number
    );

    const payload = hasExternalWeighbridgeTicket
      ? {
          consigner_type_id: Number(submissionData.consigner_type_id),
          truck_driver_name: submissionData.truck_driver_name,
          transporter_name: submissionData.transporter_name,
          truck_licence_plate: submissionData.truck_licence_plate,
          external_weigh_bridge_ticket_number:
            submissionData.external_weigh_bridge_ticket_number ||
            selectedWeighbridgeTicket?.external_weigh_bridge_ticket_number,
          contract_number: submissionData.contract_number,
          user_unique_identification_number:
            Number(submissionData.consigner_type_id) === app_consts.UAG_CONSIGNER_TYPE
              ? undefined
              : Number(submissionData.consigner_type_id) === app_consts.OTHER_CONSIGNER_TYPE
                ? undefined
              : submissionData.user_account_id,
          user_account_id: submissionData.user_account_id,
          comments: submissionData.comments,
          trailer_one: submissionData.trailer_one,
          trailer_two: submissionData.trailer_two,
          other_consigner_name: submissionData.other_consigner_name,
          first_weight: submissionData.first_weight,
          second_weight: submissionData.second_weight,
          net_weight:
            resolveGrnNetWeight(
              submissionData.net_weight,
              submissionData.first_weight,
              submissionData.second_weight,
            ) || undefined,
          weighbridge_ticket_id: submissionData.weighbridge_ticket_id,
          weigh_bridge_ticket_number: submissionData.weigh_bridge_ticket_number,
          weigh_bridge_ticket_reference_no: submissionData.weigh_bridge_ticket_reference_no,
          source_system: submissionData.source_system,
          sync_batch_id: submissionData.sync_batch_id,
          designation: submissionData.designation,
        }
      : {
          branch_location_id: Number(submissionData.branch_location_id),
          consigner_type: submissionData.consigner_type,
          contract_number: submissionData.contract_number,
          truck_driver_name: submissionData.truck_driver_name,
          user_account_id: submissionData.user_account_id,
          transporter_name: submissionData.transporter_name,
          truck_licence_plate: submissionData.truck_licence_plate,
          comments: submissionData.comments,
          trailer_one: submissionData.trailer_one,
          trailer_two: submissionData.trailer_two,
          other_consigner_name: submissionData.other_consigner_name,
        };

    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined || payload[key] === null || payload[key] === "") {
        delete payload[key];
      }
    });

    console.log("CREATE PAYLOAD JSON =>", JSON.stringify(payload, null, 2));

    dispatch(
      employee_dashboard_actions_helper(
        loading_create_goods_recieved_ticket,
        success_create_goods_recieved_ticket,
        fail_create_goods_recieved_ticket,
        CREATE_GOODS_RECEIVED_TICKET_ERR_MSG,
        CREATE_GOODS_RECEIVED_TICKET_SUCCESS_MSG,
        app_consts.POST,
        hasExternalWeighbridgeTicket
          ? ADD_GRN_FROM_NOT_SET_WEIGHBRIDGE_TICKET_API
          : CREATE_WAREHOUSE_DELIVERY_GRN_API,
        payload,
        CREATE_GOODS_RECEIVED_TICKET_ACCESS_DENIED_MSG,
      ),
    );
  };

  const create_goods_recieved_ticket = useSelector(
    (state) => state.create_goods_recieved_ticket.create_goods_recieved_ticket,
  );

  useEffect(() => {
    if (create_goods_recieved_ticket.status !== app_consts.IDLE) {
      if (create_goods_recieved_ticket.status === app_consts.LOADING) {
        setErrorVal("");
        setLoading(true);
      } else {
        setLoading(false);
        if (create_goods_recieved_ticket.status === app_consts.FAIL) {
          setErrorVal(create_goods_recieved_ticket.message);
          messageToast(create_goods_recieved_ticket.message, app_consts.FAIL);
        } else if (create_goods_recieved_ticket.status === app_consts.SUCCESS) {
          const createdGoodsReceivedData = create_goods_recieved_ticket.data || {};
          const mergedGoodsReceivedData = {
            ...createdGoodsReceivedData,
            first_weight:
              createdGoodsReceivedData?.first_weight ||
              formData?.first_weight ||
              "",
            second_weight:
              createdGoodsReceivedData?.second_weight ||
              formData?.second_weight ||
              "",
            net_weight:
              createdGoodsReceivedData?.net_weight ||
              formData?.net_weight ||
              "",
            goods_received_id:
              createdGoodsReceivedData?.goods_received_id ||
              createdGoodsReceivedData?.goods_received?.goods_received_id ||
              "",
            goods_received_ref_number:
              createdGoodsReceivedData?.goods_received_ref_number ||
              createdGoodsReceivedData?.goods_received?.goods_received_ref_number ||
              "",
          };

          setContinueProcessingData(mergedGoodsReceivedData);
          setWeighBridgeFormData((prev) => ({
            ...prev,
            ...mergedGoodsReceivedData,
            goods_received_id:
              mergedGoodsReceivedData?.goods_received_id ||
              prev.goods_received_id,
            goods_received_ref_number:
              mergedGoodsReceivedData?.goods_received_ref_number ||
              prev.goods_received_ref_number,
          }));
          messageToast(CREATE_GOODS_RECEIVED_TICKET_SUCCESS_MSG, app_consts.SUCCESS);
          nextStep();
        }
        dispatch(reset_create_goods_recieved_ticket());
      }
    }
  }, [create_goods_recieved_ticket, dispatch, nextStep, setContinueProcessingData]);

  const retrieve_product_type_list = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_product_type_list,
        success_product_type_list,
        fail_product_type_list,
        RETRIEVE_PRODUCT_TYPES_LIST_ERR_MSG,
        RETRIEVE_PRODUCT_TYPES_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_ACTIVE_PRODUCT_TYPES_LIST,
        null,
        RETRIEVE_PRODUCT_TYPES_LIST_ACCESS_DENIED_MSG,
        app_consts.MAP,
        app_consts.PRODUCT_TYPE_MAP,
      ),
    );
  };

  const retrieve_product_list = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_product_list,
        success_product_list,
        fail_product_list,
        RETRIEVE_PRODUCTS_LIST_ERR_MSG,
        RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_ACTIVE_PRODUCT_LIST,
        null,
        RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG,
      ),
    );
  };

  return (
    <>
      <Card className="card-inner">
        <CardTitle tag="h5">Select Goods Received Details</CardTitle>

        <Col lg="12">
          <div className="form-group">
            <div className="form-label-group">
              <label className="form-label text-soft">User Account :</label>
            </div>
            <div className="form-control-wrap">
              <label className="form-label text-primary">
                {weighBridgeFormData.user_account_label || "--"}
                {weighBridgeFormData.user_account_id ? ` (ID: ${weighBridgeFormData.user_account_id})` : ""}
              </label>
            </div>
          </div>
        </Col>

        <hr />

        {selectedWeighbridgeTicket && (
          <Alert color="light" className="border">
            <div className="fw-bold mb-2">Linked Weighbridge Ticket</div>
            <div>
              <b>Ticket No:</b> {effectiveFormData?.weigh_bridge_ticket_number || "--"}
            </div>
            <div>
              <b>Reference No:</b> {effectiveFormData?.weigh_bridge_ticket_reference_no || "--"}
            </div>
            <div>
              <b>Truck Plate:</b> {effectiveFormData?.truck_licence_plate || "--"}
            </div>
            <div>
              <b>Driver:</b> {effectiveFormData?.truck_driver_name || "--"}
            </div>
            <div>
              <b>Transporter:</b> {effectiveFormData?.transporter_name || "--"}
            </div>
            <div>
              <b>Net Weight (MT):</b> {effectiveFormData?.net_weight || "--"}
            </div>
          </Alert>
        )}

        {(isWeighbridgeLocked || isWeighbridgePrefilled) && (
          <Alert color="info" className="alert-icon">
            <Icon name={isWeighbridgeLocked ? "lock" : "edit"} /> Some fields were auto-filled from the selected weighbridge ticket.
            {isWeighbridgeLocked ? " Locked fields cannot be edited." : " You can edit them before creating the GRN."}
          </Alert>
        )}

        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Row className="g-4">
            <div className="form-label-group">
              <label className="form-label text-soft fs-22px">Truck Details</label>
            </div>

            <TextInput
              colSize={5}
              label="Contract Number"
              required
              type="text"
              id_val="contract_number"
              value={effectiveFormData.contract_number}
              handleChange={handleChange}
              name="contract_number"
            />

            <TextInput
              colSize={5}
              label="Transporter"
              required
              type="text"
              id_val="transporter_name"
              value={effectiveFormData.transporter_name}
              handleChange={handleChange}
              name="transporter_name"
              disabled={isWeighbridgeLocked}
            />

            <TextInput
              colSize={5}
              label="Truck Driver"
              required
              type="text"
              id_val="truck_driver_name"
              value={effectiveFormData.truck_driver_name}
              handleChange={handleChange}
              name="truck_driver_name"
              disabled={isWeighbridgeLocked}
            />

            <TextInput
              colSize={5}
              label="Truck Reg No."
              required
              type="text"
              id_val="truck_licence_plate"
              value={effectiveFormData.truck_licence_plate}
              handleChange={handleChange}
              name="truck_licence_plate"
              disabled={isWeighbridgeLocked}
            />

            <TextInput
              colSize={5}
              label="Gross Weight (MT)"
              type="number"
              id_val="first_weight"
              value={effectiveFormData.first_weight}
              handleChange={handleChange}
              name="first_weight"
              disabled={isWeighbridgeLocked}
            />

            <TextInput
              colSize={5}
              label="Tare Weight (MT)"
              type="number"
              id_val="second_weight"
              value={effectiveFormData.second_weight}
              handleChange={handleChange}
              name="second_weight"
              disabled={isWeighbridgeLocked}
            />

            <TextInput
              colSize={5}
              label="Net Weight (MT)"
              type="number"
              id_val="net_weight"
              value={effectiveFormData.net_weight}
              handleChange={handleChange}
              name="net_weight"
              disabled
            />

            <TextInput
              colSize={5}
              label="Trailer Reg 1 Reg No. (Optional)"
              type="text"
              id_val="trailer_one"
              value={effectiveFormData.trailer_one}
              handleChange={handleChange}
              name="trailer_one"
            />

            <TextInput
              colSize={5}
              label="Trailer Reg 2 Reg No. (Optional)"
              type="text"
              id_val="trailer_two"
              value={effectiveFormData.trailer_two}
              handleChange={handleChange}
              name="trailer_two"
            />

            <hr />

            <RsCol sm="10" className="mt-0">
              <div className="form-group">
                <Label htmlFor="default-textarea" className="form-label">
                  WeighBridge Ticket Comments (Optional)
                </Label>
                <div className="form-control-wrap">
                  <textarea
                    className="no-resize form-control"
                    type="textarea"
                    id="default-textarea"
                    value={effectiveFormData.comments}
                    onChange={(e) => {
                      const nextFormData = { ...effectiveFormData, comments: e.target.value };
                      setFormData(nextFormData);
                      setWeighBridgeFormData(nextFormData);
                    }}
                  />
                </div>
              </div>
            </RsCol>

            <Col xl="12">
              <div className="form-group">
                <div className="form-control-wrap-flex-wrap justify-between items center">
                  <Button className="btn btn-dim btn-outline-primary" size="md" onClick={previousStep}>
                    Previous
                  </Button>
                  <Button
                    onClick={handlePreview}
                    disabled={
                      loading
                        ? loading
                        : !(
                            effectiveFormData.contract_number &&
                            effectiveFormData.truck_driver_name &&
                            effectiveFormData.truck_licence_plate &&
                            effectiveFormData.transporter_name &&
                            (
                              Number(effectiveFormData.consigner_type_id) === app_consts.UAG_CONSIGNER_TYPE ||
                              (
                                Number(effectiveFormData.consigner_type_id) === app_consts.OTHER_CONSIGNER_TYPE &&
                                effectiveFormData.other_consigner_name
                              ) ||
                              effectiveFormData.user_account_id
                            )
                          )
                    }
                    color="primary"
                    size="md"
                  >
                    {loading ? <Spinner size="sm" color="light" /> : "Preview & Create Ticket"}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          {errorVal && (
            <div className="mt-4">
              <Alert color="danger" className="alert-icon">
                <Icon name="alert-circle" />
                {errorVal}
              </Alert>
            </div>
          )}
        </form>
      </Card>

      <ModalPreview
        openPreview={openPreview}
        setOpenPreview={setOpenPreview}
        modalTitle="Create Goods Received Preview"
        modalDescription="Please Confirm Goods Received Details and Select 'Process' to create the goods received ticket."
        moduleButtonText="Process"
        prevType={app_consts.PREVIEW_CREATE_PHYSICAL_WEIGHBRIDGE_TICKET}
        prevData={weighBridgeFormData}
        buttonFunction={handleSubmit}
      />
    </>
  );
};

export default TruckDetailsStep;
